import WarningPopup from "./WarningPopup";

export default function BulkArchiveResultAlert({ result, onClose }) {
  if (!result) return null;

  const { archived, notFound, alreadyArchived } = result;
  const total = archived.length + notFound.length + alreadyArchived.length;
  const severity =
    notFound.length === 0 && alreadyArchived.length === 0
      ? "success"
      : archived.length === 0
        ? "error"
        : "warning";

  const message =
    `Archived ${archived.length} of ${total} initiative${total !== 1 ? "s" : ""}` +
    (alreadyArchived.length > 0
      ? `; ${alreadyArchived.length} already archived`
      : "") +
    (notFound.length > 0 ? `; ${notFound.length} not found` : "");

  return (
    <WarningPopup
      message={message}
      severity={severity}
      autoHideDuration={null}
      onClose={onClose}
    />
  );
}
